import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import './BenchmarkingChatWindow.css';
import Message from "../Message/Message";

const BenchmarkingChatWindow: React.FC = () => {
    const messages = useSelector((state: RootState) => state.chatBenchmarking.messages)
    const lastmessageRef = useRef<HTMLDivElement | null>(null)
    const typingMessage = useSelector((state: RootState) => state.chatBenchmarking.typingMessage)

    useEffect(() => {
        if (lastmessageRef.current) {
            lastmessageRef.current.scrollIntoView({ behavior: 'smooth' })
        }

    }, [messages, typingMessage])

    return (
        <div className="chat-window">
            <div className="chat-messages">
                {
                    messages.map((msg, index) => (
                        <Message key={index}
                            message={{ 'message': msg.message, 'sender': msg.sender, currentModule: 'benchmarking', 'response_type': msg.response_type, 'xaxis': msg.xaxis, 'yaxis': msg.yaxis }}
                            ref={(index === messages.length - 1) ? lastmessageRef : null}

                        />
                    ))

                }
                {typingMessage && <Message message={typingMessage} ref={lastmessageRef} />}
            </div>

        </div>
    )
}

export default BenchmarkingChatWindow